import * as React from "react";
import type { SVGProps } from "react";
const SvgIcClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m12 4-8 8m0-8 8 8"
    />
  </svg>
);
export default SvgIcClose;
